import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';
import {ValidationService } from "../../core/services/validations/validations.service"

//conv dd/mm/yyyy to timestamp

export function travelerValidator(control: FormControl) {
    let travelerNumber = control.value;
    let validations = new ValidationService();
    //let day, month, year;
    if (travelerNumber) {

        var travelerNum = parseInt(travelerNumber)

        if(travelerNum > 0){
            if(travelerNum > 5) {

                return {
                            invalid : true
                        }

            }
        }

            
        

        // if(!dateMoment.isValid()){

        //     return {
        //         invalid : true
        //     }
        // }
    }


    return null;
}

@Directive({
    selector: '[travelerValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: travelerValidator,
            multi: true
        }
    ]
})
export class TravelerValidator {
}